import { lazy } from 'react';

/**
 * Wrapper around React.lazy that retries chunk loading on failure.
 * Handles transient network errors. For permanent failures (e.g. stale
 * chunk hashes after a new deployment), the ErrorBoundary should reload the page.
 */
export default function lazyWithRetry(importFn, retries = 1, delay = 1000) {
  return lazy(() => {
    return new Promise((resolve, reject) => {
      const attempt = (retriesLeft) => {
        importFn()
          .then(resolve)
          .catch((error) => {
            if (retriesLeft <= 0) {
              reject(error);
              return;
            }
            setTimeout(() => attempt(retriesLeft - 1), delay);
          });
      };
      attempt(retries);
    });
  });
}

/**
 * Check if an error is a ChunkLoadError (stale chunk after deployment).
 */
export function isChunkLoadError(error) {
  return (
    error &&
    (error.name === 'ChunkLoadError' ||
      error.message?.includes('Loading chunk') ||
      error.message?.includes('Loading CSS chunk') ||
      (error.code === 'MODULE_NOT_FOUND' && error.message?.includes('chunk')))
  );
}
